export const tvshows = [
  {
    id: "t1",
    title: "长风渡口",
    year: 2024,
    genres: ["古装", "权谋"],
    region: "中国大陆",
    director: "张晓波",
    actors: ["王凯", "江疏影", "刘奕君"],
    rating: 8.6,
    episodes: 42,
    tags: ["热播"],
    cover: "https://readdy.ai/api/search-image?query=Chinese%20historical%20costume%20drama%20poster%2C%20a%20scholar%20in%20elegant%20robes%20before%20a%20misty%20river%20ferry%20at%20dawn%2C%20deep%20navy%20tones%20with%20warm%20orange%20mist%20light%2C%20simple%20minimal%20background%2C%20cinematic%20composition%2C%20highly%20detailed%2C%20no%20text&width=400&height=600&seq=tv-cover-01&orientation=portrait",
    synopsis: "乱世渡口，一名出身寒门的读书人凭借一场被设计的科举案卷入庙堂纷争。在权谋与情义的拉扯间，他能否守住最初的理想，成为时代的摆渡人。",
  },
  {
    id: "t2",
    title: "迷雾档案",
    year: 2023,
    genres: ["悬疑", "犯罪"],
    region: "中国大陆",
    director: "五百",
    actors: ["张颂文", "李现", "王泷正"],
    rating: 8.8,
    episodes: 36,
    tags: ["热门"],
    cover: "https://readdy.ai/api/search-image?query=Gritty%20crime%20investigation%20series%20poster%2C%20case%20files%20and%20evidence%20photos%20scattered%20on%20a%20dark%20desk%20with%20a%20single%20lamp%2C%20deep%20navy%20tones%20with%20warm%20orange%20light%2C%20simple%20minimal%20background%2C%20cinematic%20detail%2C%20no%20text&width=400&height=600&seq=tv-cover-02&orientation=portrait",
    synopsis: "一宗尘封十年的悬案被重新翻开，两代刑警在不同年代追查同一串线索。档案里的每一页都在说谎，而真相藏在没有人愿意回望的过去。",
  },
  {
    id: "t3",
    title: "山海图卷",
    year: 2025,
    genres: ["奇幻", "冒险"],
    region: "中国大陆",
    director: "陈家霖",
    actors: ["杨洋", "赵丽颖", "张彬彬"],
    rating: 8.2,
    episodes: 48,
    tags: ["新剧"],
    cover: "https://readdy.ai/api/search-image?query=Epic%20fantasy%20adventure%20series%20poster%2C%20a%20traveller%20holding%20a%20glowing%20ancient%20scroll%20before%20mythical%20mountains%2C%20deep%20navy%20and%20teal%20with%20warm%20orange%20glow%2C%20simple%20minimal%20background%2C%20cinematic%20fantasy%20art%2C%20no%20text&width=400&height=600&seq=tv-cover-03&orientation=portrait",
    synopsis: "一本残缺的山海图卷牵出上古封印的传说，少女画师与守护者踏上重绘图卷的旅途。他们要在神话与现实交叠的世界里，阻止一场被写进预言的灾难。",
  },
  {
    id: "t4",
    title: "都市群像",
    year: 2022,
    genres: ["都市", "情感"],
    region: "中国大陆",
    director: "汪俊",
    actors: ["海清", "黄磊", "陶虹"],
    rating: 7.9,
    episodes: 40,
    tags: ["口碑"],
    cover: "https://readdy.ai/api/search-image?query=Modern%20urban%20ensemble%20drama%20series%20poster%2C%20several%20city%20residents%20on%20a%20rooftop%20at%20dusk%20with%20skyline%20behind%2C%20deep%20navy%20tones%20with%20warm%20orange%20sunset%2C%20simple%20minimal%20background%2C%20cinematic%20composition%2C%20no%20text&width=400&height=600&seq=tv-cover-04&orientation=portrait",
    synopsis: "同一个小区里的五组家庭，因为一场意外彼此牵连。柴米油盐之间藏着中年人的焦虑、年轻人的理想与老年人的孤独，一幅关于当代都市生活的群像。",
  },
  {
    id: "t5",
    title: "白夜诊所",
    year: 2024,
    genres: ["医疗", "剧情"],
    region: "韩国",
    director: "申源浩",
    actors: ["曹政奭", "柳演锡", "全美度"],
    rating: 8.7,
    episodes: 24,
    tags: ["佳剧"],
    cover: "https://readdy.ai/api/search-image?query=Korean%20medical%20drama%20series%20poster%2C%20a%20clinician%20standing%20in%20a%20quiet%20hospital%20corridor%20at%20night%2C%20deep%20navy%20and%20teal%20with%20warm%20orange%20light%2C%20simple%20minimal%20background%2C%20cinematic%20composition%2C%20highly%20detailed%2C%20no%20text&width=400&height=600&seq=tv-cover-05&orientation=portrait",
    synopsis: "一家只在深夜接诊的社区诊所里，几位医生用最朴素的方式守护着普通人的健康与尊严。没有奇迹，只有一次次认真对待生命的坚持。",
  },
  {
    id: "t6",
    title: "江湖夜雨",
    year: 2023,
    genres: ["武侠", "古装"],
    region: "中国大陆",
    director: "李木戈",
    actors: ["成毅", "张婧仪", "陈都灵"],
    rating: 8.4,
    episodes: 38,
    tags: ["热播"],
    cover: "https://readdy.ai/api/search-image?query=Wuxia%20martial%20arts%20drama%20poster%2C%20a%20swordsman%20in%20flowing%20robes%20beside%20a%20bamboo%20forest%20in%20the%20rain%2C%20deep%20navy%20tones%20with%20warm%20orange%20lantern%20light%2C%20simple%20minimal%20background%2C%20cinematic%20ink%20painting%20atmosphere%2C%20no%20text&width=400&height=600&seq=tv-cover-06&orientation=portrait",
    synopsis: "十年前的一场门派血案后，幸存少年隐姓埋名重入江湖。剑指何处，情归何地，他在恩义与复仇之间寻找属于自己的道。",
  },
  {
    id: "t7",
    title: "星际驿站",
    year: 2025,
    genres: ["科幻", "喜剧"],
    region: "美国",
    director: "Alex Rivera",
    actors: ["Chris Vale", "Nadia Fox", "Leo Marsh"],
    rating: 8.5,
    episodes: 20,
    tags: ["热门"],
    cover: "https://readdy.ai/api/search-image?query=Fun%20sci-fi%20comedy%20series%20poster%2C%20a%20colourful%20space%20station%20cafeteria%20window%20with%20planets%20outside%2C%20deep%20navy%20space%20with%20warm%20orange%20and%20teal%20lights%2C%20simple%20minimal%20background%2C%20cinematic%20illustration%2C%20no%20text&width=400&height=600&seq=tv-cover-07&orientation=portrait",
    synopsis: "银河边缘的一座破旧中转站里，一群不靠谱的船员经营着全宇宙最差劲的餐饮生意。每集一个荒诞又温暖的太空客人，笑料之下是漂泊者的相互慰藉。",
  },
  {
    id: "t8",
    title: "我们的旧时光",
    year: 2021,
    genres: ["青春", "校园"],
    region: "中国大陆",
    director: "刘俊杰",
    actors: ["谭松韵", "刘昊然", "郭丞"],
    rating: 8.1,
    episodes: 32,
    tags: ["经典"],
    cover: "https://readdy.ai/api/search-image?query=Nostalgic%20youth%20campus%20drama%20poster%2C%20two%20teenagers%20cycling%20under%20a%20row%20of%20summer%20trees%2C%20warm%20cream%20and%20navy%20tones%20with%20orange%20sunlight%2C%20simple%20minimal%20background%2C%20cinematic%20nostalgia%2C%20no%20text&width=400&height=600&seq=tv-cover-08&orientation=portrait",
    synopsis: "老校舍拆掉前的最后一个夏天，一群即将毕业的少年写下各自的遗憾与愿望。剧集用细碎日常记录青春里那些以为会永远、其实转瞬即逝的时刻。",
  },
  {
    id: "t9",
    title: "破晓行动",
    year: 2024,
    genres: ["谍战", "悬疑"],
    region: "中国大陆",
    director: "高群书",
    actors: ["张译", "王阳", "李一桐"],
    rating: 8.6,
    episodes: 34,
    tags: ["热播"],
    cover: "https://readdy.ai/api/search-image?query=Espionage%20thriller%20series%20poster%2C%20a%20man%20in%20a%20trench%20coat%20in%20a%20rainy%20old%20city%20alley%20at%20dawn%2C%20deep%20navy%20shadows%20with%20warm%20orange%20street%20light%2C%20simple%20minimal%20background%2C%20cinematic%20composition%2C%20no%20text&width=400&height=600&seq=tv-cover-09&orientation=portrait",
    synopsis: "黎明前的最后一年，潜伏者的身份即将暴露。一个代号、一份名单、一次注定无法回头的行动，谱写出无声战场上的信仰与牺牲。",
  },
  {
    id: "t10",
    title: "宫廷秘录",
    year: 2022,
    genres: ["古装", "历史"],
    region: "中国大陆",
    director: "郑晓龙",
    actors: ["周迅", "陈坤", "倪妮"],
    rating: 8.3,
    episodes: 46,
    tags: ["口碑"],
    cover: "https://readdy.ai/api/search-image?query=Chinese%20palace%20historical%20drama%20poster%2C%20a%20court%20lady%20in%20embroidered%20robes%20in%20a%20candlelit%20palace%20hall%2C%20deep%20navy%20and%20gold%20with%20warm%20orange%20candlelight%2C%20simple%20minimal%20background%2C%20cinematic%20composition%2C%20no%20text&width=400&height=600&seq=tv-cover-10&orientation=portrait",
    synopsis: "一部被野史与正史同时记载的宫廷档案，揭开深宫之中女性如何在权力夹缝里生存。华服之下是步步惊心，也是对命运的不甘。",
  },
  {
    id: "t11",
    title: "深巷回声",
    year: 2023,
    genres: ["悬疑", "家庭"],
    region: "中国台湾",
    director: "林君阳",
    actors: ["贾静雯", "温升豪", "吴慷仁"],
    rating: 8.5,
    episodes: 28,
    tags: ["佳剧"],
    cover: "https://readdy.ai/api/search-image?query=Family%20mystery%20drama%20series%20poster%2C%20a%20quiet%20alley%20of%20old%20townhouses%20with%20one%20lit%20window%20at%20night%2C%20deep%20navy%20tones%20with%20warm%20orange%20light%2C%20simple%20minimal%20background%2C%20cinematic%20composition%2C%20no%20text&width=400&height=600&seq=tv-cover-11&orientation=portrait",
    synopsis: "一条老街在改造前接连发生怪事，搬回祖宅的女主角发现家族往事与街坊秘密纠缠在一起。悬疑之外，是关于原生家庭与和解的细腻书写。",
  },
  {
    id: "t12",
    title: "少年游侠记",
    year: 2024,
    genres: ["武侠", "青春"],
    region: "中国大陆",
    director: "郭虎",
    actors: ["白敬亭", "赵今麦", "张晚意"],
    rating: 7.8,
    episodes: 30,
    tags: [],
    cover: "https://readdy.ai/api/search-image?query=Bright%20youth%20wuxia%20series%20poster%2C%20three%20young%20friends%20on%20horseback%20in%20a%20green%20valley%20at%20sunrise%2C%20warm%20navy%20sky%20with%20orange%20sunlight%2C%20simple%20minimal%20background%2C%20cinematic%20adventure%20mood%2C%20no%20text&width=400&height=600&seq=tv-cover-12&orientation=portrait",
    synopsis: "三个初出茅庐的少年因为一本残缺剑谱结伴闯荡江湖，在一次次啼笑皆非的冒险中学会什么是真正的侠义。轻松热血的成长故事。",
  },
  {
    id: "t13",
    title: "谜案公寓",
    year: 2025,
    genres: ["推理", "悬疑"],
    region: "日本",
    director: "石原隆",
    actors: ["菅田将晖", "长泽雅美", "中村伦也"],
    rating: 8.2,
    episodes: 12,
    tags: ["新剧"],
    cover: "https://readdy.ai/api/search-image?query=Japanese%20mystery%20series%20poster%2C%20an%20apartment%20building%20stairwell%20with%20numbered%20doors%20and%20one%20open%20door%2C%20deep%20navy%20tones%20with%20warm%20orange%20hallway%20light%2C%20simple%20minimal%20background%2C%20cinematic%20composition%2C%20no%20text&width=400&height=600&seq=tv-cover-13&orientation=portrait",
    synopsis: "一栋普通公寓，每户都藏着不为人知的秘密。新搬来的推理小说家与邻居们一起，用最日常的线索破解一桩桩看似无解的谜案。",
  },
  {
    id: "t14",
    title: "岁月说明书",
    year: 2021,
    genres: ["年代", "情感"],
    region: "中国大陆",
    director: "孔笙",
    actors: ["雷佳音", "殷桃", "宋佳"],
    rating: 8.9,
    episodes: 44,
    tags: ["经典"],
    cover: "https://readdy.ai/api/search-image?query=Retro%20period%20family%20drama%20poster%2C%20a%201980s%20factory%20town%20street%20with%20residents%20and%20bicycles%2C%20warm%20cream%20and%20navy%20tones%20with%20orange%20sunset%2C%20simple%20minimal%20background%2C%20cinematic%20nostalgia%2C%20no%20text&width=400&height=600&seq=tv-cover-14&orientation=portrait",
    synopsis: "从上世纪八十年代讲到今天，一个普通家庭随着时代浪潮起起伏伏。柴米油盐、悲欢离合，构成一本写给平凡岁月的说明书。",
  },
  {
    id: "t15",
    title: "暗涌之河",
    year: 2023,
    genres: ["犯罪", "剧情"],
    region: "英国",
    director: "Tom Hardy",
    actors: ["Olivia Maine", "Rory Blake", "Grace Odell"],
    rating: 8.4,
    episodes: 16,
    tags: ["佳剧"],
    cover: "https://readdy.ai/api/search-image?query=British%20crime%20drama%20series%20poster%2C%20a%20grim%20industrial%20riverbank%20at%20dusk%20with%20a%20lone%20figure%2C%20deep%20navy%20and%20teal%20with%20warm%20orange%20sky%2C%20simple%20minimal%20background%2C%20cinematic%20moody%20composition%2C%20no%20text&width=400&height=600&seq=tv-cover-15&orientation=portrait",
    synopsis: "一座衰落工业城市里，河水冲出了多年前的秘密。一桩旧案牵动着警察、记者与普通家庭，每个人都在暗涌之下奋力不被淹没。",
  },
  {
    id: "t16",
    title: "云端之城",
    year: 2025,
    genres: ["都市", "科幻"],
    region: "中国大陆",
    director: "文牧野",
    actors: ["易烊千玺", "舒淇", "段奕宏"],
    rating: 8.3,
    episodes: 26,
    tags: ["热门"],
    cover: "https://readdy.ai/api/search-image?query=Near-future%20urban%20sci-fi%20series%20poster%2C%20a%20city%20of%20glass%20towers%20floating%20above%20clouds%20at%20dusk%2C%20deep%20navy%20and%20teal%20with%20warm%20orange%20light%2C%20simple%20minimal%20background%2C%20cinematic%20composition%2C%20no%20text&width=400&height=600&seq=tv-cover-16&orientation=portrait",
    synopsis: "在不远的未来，人们的记忆可以上传到云端城市。一名数据修复师在整理逝者记忆时，发现了一段不该存在的自己。科技与人性的边界在此被反复叩问。",
  },
  {
    id: "t17",
    title: "逐光者",
    year: 2022,
    genres: ["励志", "剧情"],
    region: "中国大陆",
    director: "陈铭章",
    actors: ["胡歌", "唐嫣", "袁泉"],
    rating: 8.0,
    episodes: 36,
    tags: ["口碑"],
    cover: "https://readdy.ai/api/search-image?query=Inspiring%20drama%20series%20poster%2C%20a%20person%20standing%20on%20a%20hilltop%20facing%20a%20bright%20dawn%20horizon%2C%20deep%20navy%20tones%20with%20warm%20orange%20sunrise%2C%20simple%20minimal%20background%2C%20cinematic%20hopeful%20mood%2C%20no%20text&width=400&height=600&seq=tv-cover-17&orientation=portrait",
    synopsis: "一位失意的中年建筑师回到小城，接手一个几乎不可能完成的改造项目。在质疑与挫折中，他带着一群年轻人重新点亮了这座城的光。",
  },
  {
    id: "t18",
    title: "平城往事",
    year: 2020,
    genres: ["年代", "家庭"],
    region: "中国大陆",
    director: "李雪",
    actors: ["张嘉益", "闫妮", "尤勇智"],
    rating: 8.7,
    episodes: 40,
    tags: ["经典"],
    cover: "https://readdy.ai/api/search-image?query=Retro%20northern%20town%20family%20drama%20poster%2C%20a%20snowy%20old%20town%20alley%20with%20warm%20lit%20windows%20at%20evening%2C%20deep%20navy%20winter%20tones%20with%20orange%20window%20light%2C%20simple%20minimal%20background%2C%20cinematic%20nostalgia%2C%20no%20text&width=400&height=600&seq=tv-cover-18&orientation=portrait",
    synopsis: "北方小城里的一个大家庭，在时代变迁中守着一间老屋和三餐四季。琐碎日常里是亲情的重量，也是普通中国家庭的温暖缩影。",
  },
];

export const tvGenres = ["全部", "古装", "权谋", "悬疑", "犯罪", "奇幻", "冒险", "都市", "情感", "医疗", "剧情", "武侠", "科幻", "喜剧", "青春", "校园", "谍战", "历史", "推理", "年代", "励志"];
export const tvRegions = ["全部", "中国大陆", "中国台湾", "美国", "韩国", "日本", "英国"];
export const tvYears = ["全部", "2025", "2024", "2023", "2022", "2021", "2020"];